import moment from "moment";
import { DAY_FORMAT } from "constants/common";

export const formatAxisDate = (date: string) => moment(date, DAY_FORMAT).format("MM-DD");

export const formatTooltipDate = (date: string) => moment(date, DAY_FORMAT).format(DAY_FORMAT);
